(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-items-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
    const overlay = document.querySelector('.section__menu-items-overlay');
    if (!overlay) return;

    const nav = document.querySelector('.phil-primary-nav-plain');
    if (!nav) return;

    const triggers = nav.querySelectorAll('.phil-nav__link--overlay-trigger');
    const panels = overlay.querySelectorAll('.menu-items-overlay__panel');
    const backdrop = overlay.querySelector('.menu-items-overlay__backdrop');

    if (!triggers.length || !panels.length || !backdrop) return;

    let activePanelIndex = -1;
    let timeline = null;

    function cleanupInlineStyles() {
      backdrop.style.removeProperty('opacity');
      panels.forEach((panel) => {
        const cards = panel.querySelectorAll('.menu-items-overlay__product-card');
        cards.forEach((card) => {
          card.style.removeProperty('opacity');
          card.style.removeProperty('transform');
        });
      });
    }

    function hideAllPanels() {
      panels.forEach((panel) => {
        panel.hidden = true;
      });
    }

    function hideOverlay() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      hideAllPanels();
      cleanupInlineStyles();
      activePanelIndex = -1;
      if (timeline) {
        timeline.kill();
        timeline = null;
      }
    }

    function buildTimeline(panelIndex) {
      if (typeof gsap === 'undefined') return null;
      const panel = panels[panelIndex];
      if (!panel) return null;

      const cards = panel.querySelectorAll('.menu-items-overlay__product-card');
      const tl = gsap.timeline({
        defaults: { ease: 'power2.out' },
        onReverseComplete: hideOverlay
      });

      tl.set(backdrop, { opacity: 0 });
      tl.to(backdrop, { opacity: 1, duration: 0.25 });
      tl.fromTo(
        cards,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.45, stagger: 0.3 },
        '-=0.05'
      );
      return tl;
    }

    function showPanelByIndex(panelIndex) {
      hideAllPanels();
      const panel = panels[panelIndex];
      if (!panel) return false;
      panel.hidden = false;
      activePanelIndex = panelIndex;
      return true;
    }

    function openMenu(panelIndex) {
      if (!showPanelByIndex(panelIndex)) return;

      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');

      if (timeline) {
        timeline.kill();
        timeline = null;
      }

      cleanupInlineStyles();

      timeline = buildTimeline(panelIndex);
      if (!timeline) {
        backdrop.style.opacity = '1';
        return;
      }

      timeline.play(0);
    }

    function closeMenu() {
      if (overlay.hidden) return;
      if (!timeline) {
        hideOverlay();
        return;
      }
      timeline.reverse();
    }

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', (event) => {
        if (!panels[index]) return;

        event.preventDefault();
        if (!overlay.hidden && activePanelIndex === index) {
          return;
        }
        openMenu(index);
      });
    });

    backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
